import SmallRays from '../../assets/images/small-rays.svg';
import Colors from '../../constants/Colors';
import useColorScheme from '../../hooks/useColorScheme';
import { useMaxWidth } from '../../hooks/useResponsive';
import { Icon } from '../Icon';
import { TransparentView } from '../Themed';

export function HeartIcon() {
  const theme = useColorScheme();
  return (
    <Icon
      name="heart"
      style={{
        width: 50,
        height: 50,
        tintColor: Colors[theme].accent,
      }}
    />
  );
}

export function SmallRaysTop() {
  const isMobile = useMaxWidth(768);
  return (
    <TransparentView style={{ alignItems: 'center' }}>
      <SmallRays
        style={{
          width: isMobile ? 137.19 : 185.567,
          height: isMobile ? 36 : 48.693,
        }}
      />
    </TransparentView>
  );
}

export function SmallRaysBottom() {
  const isMobile = useMaxWidth(768);
  if (isMobile) {
    return null;
  }
  return (
    <TransparentView
      style={{
        transform: [{ rotate: '180deg' }],
        alignItems: 'center',
        marginVertical: 40,
      }}
    >
      <SmallRays
        style={{
          width: 185.567,
          height: 48.693,
        }}
      />
    </TransparentView>
  );
}
